/* src/app/private/components/google-config/create-google-config/create-google-config.component.scss */
label {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 5px;
}
/*# sourceMappingURL=create-google-config.component.css.map */
